export const CaretDown = () => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
        <title>Expand Dropdown Menu</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M1.01869 0.5H9.08117C9.35201 0.5 9.53951 0.630208 9.64367 0.890624C9.74784 1.15104 9.70617 1.375 9.51867 1.5625L5.48743 5.59374C5.36243 5.71874 5.2166 5.78124 5.04993 5.78124C4.88327 5.78124 4.73743 5.71874 4.61243 5.59374L0.581194 1.5625C0.393694 1.375 0.352028 1.15104 0.456194 0.890624C0.56036 0.630208 0.74786 0.5 1.01869 0.5Z" fill="#273653"></path>
    </svg>
  )
}
